<template>
  <div class="caca">
    <div v-if="balanceLoader || processing" class="payments__spinner">
      <v-progress-circular indeterminate class="redirecting-circular-progress"></v-progress-circular>
      {{ $t('Transaction.PleaseWait') }}
    </div>
    <div v-else>
      <div v-if="transactionType==='deposit'">
        <h2><v-icon color="success" class="mr-1">check_circle</v-icon>{{ $t('Payments.PNM.Completed.Headline.Deposit') }}</h2>
        <div>{{ $t('Payments.PNM.Completed.Deposit') }}</div>
      </div>
      <div v-if="transactionType==='withdrawal'">
        <h2><v-icon color="success" class="mr-1">check_circle</v-icon>{{ $t('Payments.PNM.Completed.Headline.Withdrawal') }}</h2>
        <div>{{ $t('Payments.PNM.Completed.Withdrawal') }}</div>
      </div>
      <!-- Back to homepage -->
      <div class="goto__home">
        <v-btn large color="success" @click="goToHomepage()">{{ $t('Account.ChangePassword.GoToHomepage') }}</v-btn>
      </div>
    </div>
    <PNMEventDispatcher :paymentIsCompleted="true"/>
  </div>
</template>
<script>
import store from '@/store'
import PNMEventDispatcher from '@/components/payments/PayNearMeGateway/PNMEventDispatcher'

export default {
  components: {
    PNMEventDispatcher
  },
  computed: {
    customerContext: () => store.getters['getCustomerContext'],
    balanceLoader () {
      return store.getters['getBalanceLoader']
    },
    balance () {
      return (this.customerContext && this.customerContext.Balances && this.customerContext.Balances.find(b => b.Key === 'CREDIT').Trading) || 0
    },
    transactionType: () => store.getters['payments/transactionType'],
    processing: () => store.getters['pnmGateway/processing'],
    isNotOpenedFromIFrame: () => window.top === window.self
  },
  methods: {
    goToHomepage () {
      this.$router.push({name: 'sports'})
    },
    checkTransactionAndRefreshBalance () {
      store.dispatch('pnmGateway/startPollingTransaction')
    },
    sendAnalytics () {
      if (this.isNotOpenedFromIFrame) {
        store.dispatch('payments/analytics/sendAnalytics', 'confirm')
      }
    }
  },
  mounted () {
    // this.checkTransactionAndRefreshBalance()
    this.sendAnalytics()
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/css/config"
.caca
  @media mobile-big-and-below
    background transparent
    padding 10px
  .goto__home
    margin-top 10px
    text-align center
</style>



// WEBPACK FOOTER //
// src/components/payments/PayNearMeGateway/PNMPaymentCompleted.vue